import React, { useContext, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { access_list } from "../conf";

export default function UserForm(props) {
    const {updateConnect, setAccess} = useContext(Context)
    const [load, setload] = useState(false)
    const [nom, setNom] = useState(props.user?.nom??'')
    const [prenom, setPrenom] = useState(props.user?.prenom??'')
    const [identifiant, setIdentifiant] = useState(props.user?.identifiant??'')
    const [access, Setaccess] = useState(props.user?.access??[])
    const [msg, setMsg] = useState()

    async function handleSubmit(event) {
        event.preventDefault()
        setload(true); setMsg('')
        fetch(API.concat(props.edit?`/User/by/${JSON.stringify({_id: props.user?._id})}`:'/user'), {method:props.edit?'PATCH':'POST', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({
                nom, prenom, identifiant, access: access.filter(ac=>access_list.map(a=>a.Value).includes(ac))
            })
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const user = await response.json()
                    const storedUser = JSON.parse(sessionStorage.getItem('user'))
                    if(storedUser && storedUser._id === user._id){
                        sessionStorage.setItem('user', JSON.stringify(user))
                        setAccess(user.access)
                    }
                    props.add(user); props.close()
                    setload(false)
                }else {
                    const text = await response.text()
                    setMsg(text)
                    setload(false)
                }
            }
        })
    }

    return(
        <Box component='form' onSubmit={handleSubmit} display='flex' flex={1} flexDirection='column'>
            <Typography variant="h5" align="center" marginBottom='5px'>{props.edit?'Modifier':'Créer'} un utilisateur</Typography>
            <Typography align="center" marginBottom='15px' color={'carmine.main'}>{msg}</Typography>
            <Stack direction='column' spacing={2} marginInline='20px'>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField required fullWidth label="Nom" autoComplete="family-name" autoFocus
                    error={/(?:^\s+|\s+$)/.test(nom)} helperText={/(?:^\s+|\s+$)/.test(nom) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    sx={{minWidth:'200px'}} value={nom} onChange={(event)=> setNom(event.target.value)} />
                    <TextField required fullWidth label="Prénom" autoComplete="given-name"
                    error={/(?:^\s+|\s+$)/.test(prenom)} helperText={/(?:^\s+|\s+$)/.test(prenom) && "ne doit pas commencer/finir ou ne contenir que des espaces" }
                    sx={{minWidth:'200px'}} value={prenom} onChange={(event)=> setPrenom(event.target.value)} />
                </Stack>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <TextField fullWidth label="Identifiant" 
                    sx={{minWidth:'200px'}} value={identifiant} onChange={(event)=> setIdentifiant(event.target.value)} />
                    <FormControl sx={{width:'60%', minWidth:'300px', alignSelf:'center'}}>
                        <InputLabel>Accès</InputLabel>
                        <Select required multiple fullWidth value={access} onChange={e=>Setaccess(e.target.value)} label="Accès">
                            {access_list.map(ac=><MenuItem key={ac.Value} value={ac.Value}>{ac.Label}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Stack>
            </Stack>

            <Button variant="contained" type="submit" sx={{marginTop:'20px', borderRadius:0, paddingBlock:1.5}}>Enregistrer</Button>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}